import { post } from '../axios';

interface ReportDto {
  reason: string;
  reasonDetail: string;
}

// 구독 후기, 단품 후기 신고
export const blockReview = (id: number, reportDto: ReportDto) => {
  return post(`/reviews/${id}/block`, reportDto);
};

// 집밥일기, 레시피 댓글 신고
export const blockComment = (id: number, reportDto: ReportDto) => {
  return post(`recipe/comment/${id}/block`, reportDto);
};

// 집밥일기 신고
export const blockDiaryDetail = (id: number, reportDto: ReportDto) => {
  return post(`/recipe/diary/${id}/block`, reportDto);
};

// 레시피 신고
export const blockRecipeDetail = (id: number, reportDto: ReportDto) => {
  return post(`/recipe/${id}/block`, reportDto);
};
